import { format } from "date-fns";
import { fr } from "date-fns/locale";
import type {
  Equipment,
  EquipmentAttributeDefinition,
} from "../../../api/equipment/Equipment.typed";
import type { RentalItem } from "../../../api/rental/Rental.typed";

export function equipmentLabel(eq?: Equipment | null, fallback?: string): string {
  if (!eq) return fallback ?? "—";
  const name =
    (eq.Attributes?.Name as string | undefined) || (eq.Attributes?.Reference as string | undefined);
  if (name) return name;

  return eq.ID ? eq.ID.slice(0, 8) : (fallback ?? "—");
}

export function itemLabel(item: RentalItem | null | undefined): string {
  if (!item) return "—";
  const fallback = item.equipment_id ? item.equipment_id.slice(0, 8) : "—";

  return equipmentLabel(item.equipment, fallback);
}

// Stringifies an equipment attribute value using its definition (date → fr format, comments → count).
export function formatAttributeValue(attr: EquipmentAttributeDefinition, raw: unknown): string {
  if (raw == null || raw === "") return "";

  if (attr.Type === "comments") {
    return Array.isArray(raw) ? String(raw.length) : "";
  }

  if (attr.Type === "date") {
    try {
      return format(new Date(raw as string), "dd MMM yyyy", { locale: fr });
    } catch {
      return String(raw);
    }
  }

  return String(raw);
}
